import { render, staticRenderFns } from "./crudWhatsapp.vue?vue&type=template&id=0c32b8b6&scoped=true&"
import script from "./crudWhatsapp.vue?vue&type=script&lang=js&"
export * from "./crudWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./crudWhatsapp.vue?vue&type=style&index=0&id=0c32b8b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c32b8b6",
  null
  
)

export default component.exports